import React, { useState } from "react";
import emailjs from "emailjs-com";
import "../assets/css/footer.css";

import { ReactComponent as Facebook } from "../assets/icons/Facebook.svg";
import { ReactComponent as Instagram } from "../assets/icons/Instagram.svg";
import { ReactComponent as WhatsApp } from "../assets/icons/Whatsapp.svg";
import { ReactComponent as TikTok } from "../assets/icons/Tiktok.svg";
import { ReactComponent as Linkedin } from "../assets/icons/Linkedin.svg";
import mail from "../assets/svg/Mail.svg";
import enviar from "../assets/svg/send.svg";
import logoFooter from "../assets/svg/logoFooter.svg";
import logoFooter2 from "../assets/svg/logoFooter2.svg";
import reclamaciones from "../assets/img/reclamaciones.png";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    emailjs
      .send(
        "service_0yqdsmk", // Reemplaza con tu Service ID
        "template_0shjcue", // Reemplaza con tu Template ID
        { email: email },
        "FiOrOg8ZmLDpRXaoR" // Reemplaza con tu User ID
      )
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setEmail("");
          setTimeout(() => setSuccess(false), 2000);
        },
        (error) => {
          setLoading(false);
          console.error("Error al enviar el correo:", error);
        }
      );
  };

  return (
    <div className="footer">
      <div className="seccion1">
        <div className="columna1">
          <div className="columna-logo">
            <div className="logo">
              <img
                src={logoFooter}
                alt="Logo de Footer"
                className="logo-desktop"
              />
              <img
                src={logoFooter2}
                alt="Logo de Footer"
                className="logo-mobile"
              />
            </div>
          </div>
          <div className="columna-iconosRedes">
            <a
              href="https://www.facebook.com/TyTasesores"
              target="_blank"
              rel="noopener noreferrer"
              className="Facebook"
            >
              <Facebook />
            </a>
            <a
              href="https://www.instagram.com/estudiostte/"
              target="_blank"
              rel="noopener noreferrer"
              className="Instagram"
            >
              <Instagram />
            </a>
            <a
              href="https://wa.me/51988070758"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsApp"
            >
              <WhatsApp />
            </a>

            <a
              href="https://www.tiktok.com/@estudiotyt"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsApp"
            >
              <TikTok />
            </a>
            <a
              href="https://www.linkedin.com/in/torres-y-torres-29bb39349/"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsApp"
            >
              <Linkedin />
            </a>
          </div>
        </div>
        <div className="columan2">
          <h4>Contáctanos</h4>
          <p>administracion@estudiott.com</p>
          <p>Los Cocoteros 473, Víctor Larco Herrera 13009</p>
          <p>+51 988 070 758</p>
        </div>

        <div className="columna3">
          <div className="suscribete">
            <h4>Suscríbete</h4>
            <p>
              Ingresa tu email y nosotros te notificaremos sobre noticias
              legales o empresariales
            </p>
          </div>
          <form onSubmit={handleSubmit} className="boton-email">
            <div className="input-container">
              <button type="submit" disabled={loading}>
                {!success ? (
                  <>
                    <input
                      type="email"
                      className="input-email"
                      placeholder="Ingresa tu email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                    {email && !loading ? (
                      <img src={enviar} alt="Enviar" />
                    ) : loading ? (
                      "Enviando correo..."
                    ) : (
                      <img src={mail} alt="Mail" />
                    )}
                  </>
                ) : (
                  <span className="success-message">
                    ¡Gracias por suscribirte!
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
  

      <div className="seccion2">
      <div className="colum-reclamaciones">
        <p>
          <a href="/libro_reclamaciones" className="boton-reclamaciones">
            <img
              src={reclamaciones}
              alt="Libro de Reclamaciones"
              className="libro-reclamaciones"
            ></img>
          </a>
        </p>
      </div>
        <p>©2025 Target Marketing Perú. Todos los derechos reservados</p>
      </div>
    </div>
  );
};

export default Footer;
